import React from "react";

const ICON_MAP = {
  // Core self & mind
  SELF_DISCIPLINE: "🧭",
  EMOTIONAL_REGULATION: "🌙",
  COMMUNICATION_CLARITY: "💬",
  ETHICAL_ALIGNMENT: "⚖️",

  // Life responsibility
  PROFESSIONAL_DISCIPLINE: "🏛",
  RELATIONSHIP_MATURITY: "🤝",
  HEALTH_ROUTINE_AWARENESS: "🩺",
  FINANCIAL_PRUDENCE: "💰",

  // Pressure & transformation
  ADDICTION_GUARDING: "🛑",
  IMPULSE_CONTROL: "🔥",
  CHANGE_ACCEPTANCE: "🔄",

  // Growth & support
  SPIRITUAL_GROUNDING: "🪷",
  SERVICE_ORIENTATION: "🙏",
  LEARNING_COMMITMENT: "📚",

  // Optional signals
  BOUNDARY_SETTING: "🛡️",
  RESTORATION_AFTER_STRESS: "🌿",
  SOCIAL_DISCERNMENT: "🧠"
};

const TONE_STYLE = {

  gentle: {
    bg: "rgba(96,165,250,0.10)",
    border: "rgba(96,165,250,0.25)"
  },

  reflective: {
    bg: "rgba(168,85,247,0.10)",
    border: "rgba(168,85,247,0.25)"
  },

  uplifting: {
    bg: "rgba(34,197,94,0.10)",
    border: "rgba(34,197,94,0.25)"
  },

  advisory: {
    bg: "rgba(251,191,36,0.10)",
    border: "rgba(251,191,36,0.25)"
  },

  supportive: {
    bg: "rgba(45,212,191,0.10)",
    border: "rgba(45,212,191,0.25)"
  },

  protective: {
    bg: "rgba(244,63,94,0.10)",
    border: "rgba(244,63,94,0.25)"
  },

  reassuring: {
    bg: "rgba(148,163,184,0.10)",
    border: "rgba(148,163,184,0.25)"
  },

  encouraging: {
    bg: "rgba(59,130,246,0.10)",
    border: "rgba(59,130,246,0.25)"
  }

};

function formatTitle(id){
  return id
    ?.toLowerCase()
    ?.replace(/_/g," ")
    ?.replace(/\b\w/g,l=>l.toUpperCase());
}

export default function AwarenessGuidance({signals=[]}){

    const visible = Array.isArray(signals) ? signals.slice(0, 3) : [];

    return (

    <div style={{
    borderRadius:12,
    border:"1px solid rgba(148,163,184,0.12)",
    background:"linear-gradient(180deg, rgba(15,23,42,0.92), rgba(15,23,42,0.85))",
    padding:18,
    marginTop:4
    }}>

    {/* Header */}

    <div style={{marginBottom:14}}>

    <div style={{
    fontSize:15,
    fontWeight:650,
    display:"flex",
    alignItems:"center",
    gap:8,
    color:"#e2e8f0"
    }}>
    🌙 Active Signals — This Dasha Period
    </div>

    <div style={{
    fontSize:12.5,
    color:"#94a3b8",
    marginTop:4,
    lineHeight:1.6
    }}>
    These are not fixed traits. They are patterns your active planets tend
    to surface during this period — worth noticing, not worth worrying about.
    </div>

    </div>


    {/* No signals case */}

    {visible.length === 0 && (

    <div style={{
    fontSize:13,
    color:"#94a3b8",
    padding:"10px 0",
    opacity:0.9
    }}>
    No specific awareness signals are highlighted for this phase.  
    Continue focusing on steady routines and balanced actions.
    </div>

    )}


    {/* Signals grid */}

    {visible.length > 0 && (

    <div style={{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(220px,1fr))",
    gap:14
    }}>

    {visible.map((s,i)=>{

    const icon = ICON_MAP[s.signal_id] || "✨";
    const tone = TONE_STYLE[s.tone_hint] || {};

    return(

    <div
    key={i}
    style={{
    padding:14,
    borderRadius:10,
    background:tone.bg || "rgba(255,255,255,0.04)",
    border:`1px solid ${tone.border || "rgba(255,255,255,0.08)"}`,
    transition:"all 0.2s ease"
    }}
    >

    {/* Title */}

    <div style={{
    fontWeight:600,
    marginBottom:6,
    display:"flex",
    alignItems:"center",
    gap:8
    }}>

    <span style={{
    display:"inline-flex",
    alignItems:"center",
    justifyContent:"center",
    width:26,
    height:26,
    borderRadius:"50%",
    background:"rgba(255,255,255,0.08)",
    fontSize:14
    }}>
    {icon}
    </span>

    {formatTitle(s.signal_id)}

    </div>


    {/* Theme text */}

    <div style={{
    fontSize:13,
    lineHeight:1.5,
    color:"#cbd5f5"
    }}>
    {s.theme}
    </div>


    {/* Optional source hint */}

    {s.source_refs?.length > 0 && (

    <div style={{
    marginTop:8,
    fontSize:11,
    color:"#64748b",
    opacity:0.8,
    fontStyle:"italic"
    }}>
    Active in: {s.source_refs[0]} period
    </div>

    )}

    </div>

    )

    })}

    </div>

    )}

    </div>

    )

}